import script from "./HomeWelcome.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeWelcome.vue?vue&type=script&setup=true&lang=ts"

import "./HomeWelcome.vue?vue&type=style&index=0&id=0e5fbaa4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e5fbaa4"]])

export default __exports__